var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSsoIcon = function SvgSsoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.49c0 .633-.39 1.175-.944 1.396L9.5 12h-2l.444-3.114a1.504 1.504 0 0 1 .556-2.9c.828 0 1.5.673 1.5 1.503Z",
    fill: "#44485F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.118 8.5 2 2 4.118v2.418c0 4.118 2.47 7.832 6.262 9.416a.616.616 0 0 0 .476 0A10.202 10.202 0 0 0 15 6.536V4.118ZM3 6.536v-1.69l5.5-1.792L14 4.846v1.69a9.2 9.2 0 0 1-5.5 8.428A9.2 9.2 0 0 1 3 6.536Z",
    fill: "#44485F"
  })));
};
export default SvgSsoIcon;